import { render, staticRenderFns } from "./TenderVersionDropdown.vue?vue&type=template&id=413aa737&scoped=true&"
import script from "./TenderVersionDropdown.vue?vue&type=script&lang=js&"
export * from "./TenderVersionDropdown.vue?vue&type=script&lang=js&"
import style0 from "./TenderVersionDropdown.vue?vue&type=style&index=0&id=413aa737&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413aa737",
  null
  
)

export default component.exports